function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.98237 6.3035C8.95037 6.3035 8.91837 6.3075 8.88637 6.3155C5.91637 7.0465 3.50037 10.2645 3.50037 13.4885C3.50037 17.5445 6.80037 20.8445 10.8574 20.8445C14.5144 20.8445 17.5704 18.2395 18.1244 14.6495C18.1284 14.6195 18.1424 14.5325 18.0604 14.4355C17.9824 14.3445 17.8584 14.2905 17.7284 14.2905C16.3174 14.2905 15.2404 14.3225 14.3994 14.3465C12.3634 14.4075 11.5214 14.4305 10.6894 13.8135C9.43537 12.8845 9.32937 11.2885 9.32937 6.5945C9.32937 6.5105 9.29337 6.4405 9.22137 6.3845C9.15437 6.3315 9.06937 6.3035 8.98237 6.3035ZM10.8574 22.3445C5.97337 22.3445 2.00037 18.3715 2.00037 13.4885C2.00037 9.6165 4.92837 5.7445 8.52737 4.8585C9.08937 4.7215 9.69337 4.8495 10.1474 5.2035C10.5804 5.5435 10.8294 6.0505 10.8294 6.5945C10.8294 10.9795 10.9774 12.1595 11.5824 12.6085C11.9794 12.9015 12.5234 12.8985 14.3564 12.8475C15.2084 12.8225 16.2994 12.7905 17.7284 12.7905C18.2984 12.7905 18.8354 13.0345 19.1994 13.4595C19.5374 13.8545 19.6854 14.3705 19.6074 14.8785C18.9394 19.2035 15.2594 22.3445 10.8574 22.3445Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Clip 4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.474 1.00049H22.893V11.2898H12.474V1.00049Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0108 2.5018C13.9008 5.0208 14.0638 8.2748 14.1398 9.5638C14.1438 9.6408 14.1998 9.6968 14.2758 9.7008C15.3038 9.7598 18.8458 9.9238 21.3928 9.5488C21.3988 8.1448 20.4378 6.2408 18.9908 4.7948C17.5068 3.3128 15.7508 2.5018 14.0328 2.5018H14.0108ZM17.3148 11.2898C16.0048 11.2898 14.8518 11.2368 14.1888 11.1988C13.3548 11.1498 12.6908 10.4848 12.6428 9.6508C12.5648 8.3288 12.3958 4.9698 12.5158 2.3718C12.5488 1.6168 13.1588 1.0158 13.9048 1.0028C16.0418 0.940803 18.2468 1.9328 20.0508 3.7338C21.8088 5.4908 22.9248 7.7998 22.8928 9.6168C22.8808 10.3258 22.3658 10.9178 21.6698 11.0228C20.3118 11.2278 18.7218 11.2898 17.3148 11.2898Z",
  fill: "black"
}));

var SvgDeepDive = function SvgDeepDive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/DeepDive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graph"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 1,
    width: 11,
    height: 11
  }, _ref3), _ref4))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeepDive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DeepDive.0ff53027.svg";
export { ForwardRef as ReactComponent };